<template>
    <div class="con">
        <div class="tit-head">
            <div :class="[{'rightT':status == 1},{'errorT':status == -1}]">判断题</div>
            <!-- <div class="stem" v-html="info.title"></div> -->
            <mavonEditor 
                :class="[{'right':status == 1},{'error':status == -1}]"
                :boxShadow="false" 
                styleEditor="min-height: 20px;width: auto;" 
                :content="info.title" 
                :subfield="false" 
                :toolbarsFlag="false" 
                previewBackground="#fff"
                defaultOpen="preview" 
            />
        </div>
        <div v-if="status">
            <div class="log log_r" v-if="status == 1"><Icon type="md-checkmark" size='26'/></div>
            <div class="log log_e" v-else><Icon type="md-close" size='26'/></div>
        </div>
        <div class="jugle">
            <Radio-group v-model="yourAnswer" vertical>
                <Radio label="A" disabled>
                    <span>A、正确</span>
                </Radio>
                <Radio label="B" disabled>
                    <span>B、错误</span>
                </Radio>
                </Radio-group>
        </div>
        <div class="right-key"><span>正确答案：{{correctAnswer}} </span> <span @click="showResolute" v-if="txtSolution || videoSolution">显示解析</span></div>
        <div class="resolve" v-if="showResolutionBox  && (txtSolution||videoSolution)" >
            <div class="text" v-if="txtSolution">
                <div style='color:#FF9D00'>文字解析：</div>
                <div v-html="txtSolution"></div>
            </div>
            <div class="video" v-if="videoSolution">
                <div>视频解析：</div>
                <video :src="videoSolution" controls></video>
            </div>
        </div>
    </div>
</template>
<script>
import mavonEditor from './mavonEditor.vue'
export default {
    components:{ mavonEditor },
    props:{
        info:{
            type:Object,
            default:null
        },
        correctAnswer:{
            type:String,
            default:null
        },
        yourAnswer:{
            type:String,
            default:null
        },
        txtSolution:{
            type:String,
            default:null
        },
        videoSolution:{
            type:String,
            default:null
        },
        status:{
            type:Number,
            default:null
        }
    },
    data(){
        return{
            showResolutionBox: false,
        }
    },
    created(){
        if(this.correctAnswer){
            this.jugleAnswer = this.correctAnswer
        }
    },
    methods:{
        showResolute(){
            this.showResolutionBox = !this.showResolutionBox
        },
    }
}
</script>
<style lang="less" scoped>
@import './style/common.less';

.jugle {
    margin-left: 50px;
    .ivu-radio-wrapper {
    display: flex;
    align-items: center;
    margin: 10px 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/practise/components/questionJugleView.vue